import React, { useState } from "react"
import { useFilterNews } from "./hooks"
import styled from "styled-components"
import Container from "@/components/common/Container"
import PaginationBar from "@/components/common/PaginationBar"
import Cards, { CARDS_TYPE } from "@/components/common/Cards"
import { getCssSizeValue } from "@/utils/utils"
import { BREAKPOINTS } from "@/styles/themeSettings"
import NoResultsLottie from "@/components/noResultsLottie/NoResultsLottie"
import Filtration from "@/components/articlesWithPagination/Filtration"

const ArticlesWithPaginationWrapper = styled.div`
	font-family: ${({ theme }) => theme.fontFamily.bornaFont};
`

const Wrapper = styled(Container)`
	--row-gap: ${getCssSizeValue(90, BREAKPOINTS.DESKTOP)};
	display: flex;
	flex-direction: column;
	row-gap: calc(var(--row-gap) / 2);
	padding-bottom: var(--row-gap);
	align-items: center;
`

const ArticlesWithPagination = ({ data = [], categories = [], horizontalCards = false, renderFiltration = true, showDate = true }) => {
	const [isGrid, setIsGrid] = useState(true)

	const {
		filteredData,
		totalPages,
		currentPage,
		dropdownCategories,
		handleCategoryChange,
		selectedCategoriesFromQuery,
		startDateFromQuery,
		endDateFromQuery,
		handleStartDateChange,
		handleEndDateChange,
		handlePageClick,
		handleResetFiltration,
		handleRemoveSingleFilter,
		isFilterApplied,
		ContainerRef,
	} = useFilterNews(data, categories)

	const noResults = filteredData.length === 0

	return (
		<Wrapper ref={ContainerRef}>
			{renderFiltration && (
				<Filtration
					isGrid={isGrid}
					setIsGrid={setIsGrid}
					dropdownCategories={dropdownCategories}
					handleCategoryChange={handleCategoryChange}
					selectedCategoriesFromQuery={selectedCategoriesFromQuery}
					startDateFromQuery={startDateFromQuery}
					endDateFromQuery={endDateFromQuery}
					handleStartDateChange={handleStartDateChange}
					handleEndDateChange={handleEndDateChange}
					handleResetFiltration={handleResetFiltration}
					handleRemoveSingleFilter={handleRemoveSingleFilter}
					isFilterApplied={isFilterApplied}
				/>
			)}

			<ArticlesWithPaginationWrapper>
				{!noResults ? (
					<Cards
						isAllNewsPage={true}
						data={filteredData}
						type={isGrid ? CARDS_TYPE.GRID : CARDS_TYPE.LIST}
						animation
						date={showDate}
						paginate
						horizontalCards={horizontalCards}
					/>
				) : (
					<NoResultsLottie variant="white" />
				)}
			</ArticlesWithPaginationWrapper>
			{!noResults && <PaginationBar currentPage={currentPage} numberOfPages={totalPages} handleClick={handlePageClick} />}
		</Wrapper>
	)
}

export default ArticlesWithPagination
